import { render, staticRenderFns } from "./UPEICalorimetryPreLabPt2V2.vue?vue&type=template&id=49fdfa4f&"
import script from "./UPEICalorimetryPreLabPt2V2.vue?vue&type=script&lang=js&"
export * from "./UPEICalorimetryPreLabPt2V2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VFileInput,VSimpleTable})
